import rtk /* , {set, update } */ from 'rtk'
import { name, history } from './constants'
import { locationChange, push, replace, back, forward, go } from './actions'
const { createReducer } = rtk(name)

const initialState = {
    location: history.location,
}

export const reducer = createReducer(initialState, {
    [locationChange]: (state, { payload }) => {
        state.location = payload.location
    },
    [push.fulfilled]: (state, { payload }) => {
        state.location = payload.location
    },
    [replace.fulfilled]: (state, { payload }) => {
        state.location = payload.location
    },
    [back.fulfilled]: (state, { payload }) => {
        state.location = payload.location
    },
    [forward.fulfilled]: (state, { payload }) => {
        state.location = payload.location
    },
    [go.fulfilled]: (state, { payload }) => {
        state.location = payload.location
    },
})
